<template>
  <el-tag v-if="criticalLevel && stateLabel" size="medium" :type="cssClass"
  >{{ stateLabel }}
  </el-tag>
</template>

<script>
  import constants from "../../../constants";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";

  export default {
    name: "hc-phonghop-critical-level-tag",
    props: ["criticalLevel"],

    computed: {
      stateLabel() {
        return hanhChinhUtils.getPhongHopCriticalLevelLabel(this.criticalLevel);
      },

      cssClass() {
        switch (this.state) {
          case constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.KHONG_LANH_DAO:
            return "info";
          case constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.CO_LANH_DAO:
            return "warning";
          case constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.QUAN_TRONG:
            return "danger";
          default:
            return "";
        }
      }
    },

    methods: {}
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-phonghop-critical-level-tag.vue